export default __webpack_public_path__ + "static/media/ic_progress_chart.fab4b690.png";